import React from "react";
// import Front from "../home/front";
import Testimonials from "./Testimonial";

const TestimonialPage = () => {
  return (
    <>
      {/* <Front /> */}
      <Testimonials />
    </>
  );
};

export default TestimonialPage;
